// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconChampagne = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M13 5V1h-2v4z" />,
    <path
      fillRule="evenodd"
      d="M3.69 9.169l7.727 2.07-1.036 3.864a4 4 0 01-3.9 2.966l-.55 2.053.966.26-.518 1.931-3.864-1.035.518-1.932.966.259.55-2.054a4 4 0 01-1.895-4.518zM6 15.999a2 2 0 002.45-1.413l.517-1.932-3.864-1.036-.517 1.932A2 2 0 006 16m14.503-6.831l-7.728 2.07 1.036 3.864a4 4 0 003.9 2.966l.55 2.053-.966.26.518 1.931 3.864-1.035-.518-1.932-.966.259-.55-2.054a4 4 0 001.895-4.518zm-2.311 6.83a2 2 0 01-2.45-1.413l-.517-1.932 3.864-1.036.517 1.932A2 2 0 0118.192 16"
    />,
    <path d="M6.707 3.543L9.536 6.37 8.12 7.785 5.293 4.957zm9.172 4.243l2.828-2.829-1.414-1.414-2.828 2.828z" />
  );
export default SvgIconChampagne;
